import React from "react";
import LojaFormEdit from "../../components/LojaForm/LojaFormEdit";

function LojaFormEditPage() {
  return (
    <>
      <LojaFormEdit />
    </>
  );
}

export default LojaFormEditPage;
